import {PDFDocument} from 'pdf-lib';
import {PDFFont, PDFImage, PDFPage, StandardFonts} from 'pdf-lib/cjs/api';
import {Profile} from '../model/profile.model';
import {LANGUAGES} from './lang';

export interface MyPDFInput {
  event_name: string;
  event_datetime: string;
  event_ticket_file_name: string;
  event_long_description: string;
}

export class MyPDFDownloader {
  private input: MyPDFInput;

  private PAGE_SIZE: [number, number] = [595.28, 841.89];
  private PAGE_SCALE: [number, number] = [7, 7];
  private TITLE_SIZE: number = 27;
  private NORMAL_SIZE: number = 20;
  private SMALL_SIZE: number = 15;

  async downloadTickets(input: MyPDFInput, profiles: any[], lang?: string) {
    this.input = input;

    const pdfDoc: PDFDocument = await PDFDocument.create();

    const myFont: PDFFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const pngImageBytes = await fetch('assets/img/Costa.png').then((res) =>
      res.arrayBuffer()
    );
    const pngImage = await pdfDoc.embedPng(pngImageBytes);

    profiles.forEach((el) => {
      let page = pdfDoc.addPage(this.PAGE_SIZE);

      this.createSingleTicket(el, page, pngImage, myFont, lang);
      page.scale(this.PAGE_SCALE[0], this.PAGE_SCALE[1]);
    });

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([new Uint8Array(new Uint32Array([pdfBytes.length]).buffer), new Uint8Array(pdfBytes)], { type: 'application/pdf'});

    const url = window.URL.createObjectURL(blob);

    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    let title = '';
    if (!!lang && lang == LANGUAGES.it) {
      title = 'Conferma_prenotazione_';
    }
    // if (!!lang && lang == 'en') {
    //   title = 'Confirmation_of_reservation_';
    // }
    // if (!!lang && lang == 'de') {
    //   title = 'Confirmation_of_reservation_';
    // }
    // if (!!lang && lang == 'fr') {
    //   title = 'Confirmation_of_reservation_';
    // }
    anchorElement.download =
      title +
      this.input.event_name +
      '_' +
      this.input.event_ticket_file_name +
      '.pdf';
    anchorElement.target = '_blank';

    anchorElement.click();
    anchorElement.remove();
    URL.revokeObjectURL(url);
  }

  private createSingleTicket(
    profile: Profile,
    page: PDFPage,
    image: PDFImage,
    font: PDFFont,
    lang?: string
  ) {
    page.setFont(font);

    let final_imgWidth = page.getWidth() / 6;

    page.drawImage(image, {
      x: (page.getWidth() - final_imgWidth) / 2,
      y: 720,
      width: final_imgWidth,
      height: image.height * (final_imgWidth / image.width),
    });

    let titleString: string = '';
    if (!!lang && lang == LANGUAGES.it) {
      titleString = 'Conferma prenotazione ';
    }
    // if (!!lang && lang == 'en') {
    //   titleString = 'Confirm reservation ';
    // }
    // if (!!lang && lang == 'de') {
    //   titleString = 'Confirm reservation ';
    // }
    // if (!!lang && lang == 'fr') {
    //   titleString = 'Confirm reservation ';
    // }
    const titleWidth = font.widthOfTextAtSize(titleString, this.TITLE_SIZE);
    page.drawText(titleString, {
      x: (page.getWidth() - titleWidth) / 2,
      y: 650,
      size: this.TITLE_SIZE,
    });

    const indent: number = 50;

    page.drawText(this.input.event_name, {
      x: indent,
      y: 570,
      size: this.NORMAL_SIZE,
    });
    page.drawText(this.input.event_datetime, {
      x: indent,
      y: 540,
      size: this.NORMAL_SIZE,
    });

    const profileLine: string = profile.badgeNumber
      ? `${profile.displayName} - ${profile.badgeNumber}`
      : `${profile.displayName}`;
    page.drawText(profileLine, { x: indent, y: 510, size: this.NORMAL_SIZE });
    page.drawText(this.input.event_long_description, {
      x: indent,
      y: 470,
      size: this.SMALL_SIZE,
      maxWidth: page.getWidth() - indent * 2,
    });
    // if (!!lang && lang == 'it') {
    //   page.drawText(this.input.event_long_description.it!, {
    //     x: indent,
    //     y: 470,
    //     size: this.SMALL_SIZE,
    //     maxWidth: page.getWidth() - indent * 2,
    //   });
    // }
    // if (!!lang && lang == 'en') {
    //   page.drawText(this.input.event_long_description.en!, {
    //     x: indent,
    //     y: 470,
    //     size: this.SMALL_SIZE,
    //     maxWidth: page.getWidth() - indent * 2,
    //   });
    // }
    // if (!!lang && lang == 'de') {
    //   page.drawText(this.input.event_long_description.de!, {
    //     x: indent,
    //     y: 470,
    //     size: this.SMALL_SIZE,
    //     maxWidth: page.getWidth() - indent * 2,
    //   });
    // }
    // if (!!lang && lang == 'fr') {
    //   page.drawText(this.input.event_long_description.fr!, {
    //     x: indent,
    //     y: 470,
    //     size: this.SMALL_SIZE,
    //     maxWidth: page.getWidth() - indent * 2,
    //   });
    // }
  }
}
